import { RadioGroupProps } from '@amzn/awsui-components-react-v3';

import { ERROR_CODES } from '../../constants';
import { ContainerType } from '../../store/types';

const { network_error } = ERROR_CODES;

export const CMS_TICKET_TEMPLATE_URL = "https://t.corp.amazon.com/create/templates/689c4e95-8250-411d-a892-c22e995f9d19";

export const CONTAINERS_ERROR_CODES: any = {
  container_id_not_found: 'container_id_not_found',
  network_error: 'network_error',
  CONTAINER_MANAGEMENT_SERVICE_NOT_AVAILABLE: 'CONTAINER_MANAGEMENT_SERVICE_NOT_AVAILABLE',
};

export const CONTAINERS_ERROR_CODES_MAPPING: any = {
  container_id_not_found: 'Invalid container, Please check again and scan the right container id',
  CONTAINER_IS_INACTIVE: 'Scanned container exists but is not active',
  CONTAINER_DOES_NOT_EXIST: 'Invalid container, Please check again and scan the right container id',
  CONTAINER_NOT_AT_LOCATION: 'Scanned container exists, but not at this location',
  CONTAINER_MANAGEMENT_SERVICE_NOT_AVAILABLE:
    `Container Management Service is currently experiencing a temporary issue, please try again in a few minutes. If the issue persists, create a ticket <a href=${CMS_TICKET_TEMPLATE_URL}>here</a>.`,
  network_error,
};

export const CONTAINER_ID_NOT_FOUND_METRIC = 'ContainerNotFound';

export const CONTAINER_RADIO_TYPES: RadioGroupProps.RadioButtonDefinition[] = [
  { value: ContainerType.BIN, label: 'Bin' },
  { value: ContainerType.TOTE, label: 'Tote' },
];